export const blockedCheckbox = [
  {
    value: "blockUser",
    key: "I would also like to block this user.",
  },
];
